import NonAuthLayoutWrapper from "components/NonAutnLayoutWrapper";
import { createSelector } from "reselect";
import { useRedux } from "./hooks/index";
 import { setCurrentUser, clearCurrentUser } from "./redux/profile2/p2_reducer";
// import { clearCurrentUser, setCurrentUser } from "./helpers/utils"
import { UserStruct } from "api";

const TestElement = () => {
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Login,
    (state: any) => state.Profile2,
    (login, profile2) => ({
      error: login.error,
      something: profile2
    })
  );
  const { error, something } = useAppSelector(errorData);

  // const errorData2 = createSelector(
  //   (state: any) => state,
  //   (state) => ({
  //     error: state.Login.error,
  //     something: state.Profile2.userName
  //   })
  // );  

  // const { error2, something2 } = useAppSelector(errorData2);
  const t = (bSet: boolean) => {
    if (bSet) {
      // console.log(something);
      const data: UserStruct = {
        nickName: "Hello World ddd"
      };
      dispatch(setCurrentUser(data));
    } else {
      dispatch(clearCurrentUser("TestElement", "Just Test Element"));
    }

  }

  return (
    <NonAuthLayoutWrapper>
      <span>Error = {error}</span>
      <span>Somthing = {something.nickName}</span>
      <button onClick={() => t(true)}>SetUser</button>
      <button onClick={() => t(false)}>CleaUser</button>
    </NonAuthLayoutWrapper>
  );

}
export default TestElement;